<template>
  <div class="categoryContainer">
    <div v-if="isCheckedAll && listData.length" class="checkbox mb10">
      <input type="checkbox" id="checkCategoryAll" v-model="checkedAll" @change="onCheckedAll"><label for="checkCategoryAll">{{locale.all}}</label>
    </div>
    <div :class="`treeList ${modes}`">
      <CategoryItem v-for="(item, index) in listData" :key="item.id"
        :item="item"
        :rootIndex="index"
        :mode="mode"
        :depth="depth"
        :option="options"
        :state="states"
        :setCheckItem="setChecks"
        @addItem="addItem"
        @removeItem="removeItem"
        @checked="checked"
        @selected="selected" />
      <UnCategorized v-if="options.unCategorized"
        :item="unCategorized"
        :option="options"
        :state="states"
        :setCheckItem="setChecks"
        @checked="checked"
        @selected="selected" />
    </div>
    <button v-if="edit" type="button" class="btn btnWhite btnFull btnAdd" @click="addList">+</button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UNIQUE from '@/common/unique.js'
import CategoryItem from '@/components/Category/Item'
import UnCategorized from '@/components/Category/UnCategorized'

const defaultMode = 'default' // default, compact ... just skin

const defaultOption = {
  folder: true,
  selected: false,
  checkbox: false,
  checkAll: false,
  open: true,
  editItem: true,
  editLabel: true,
  unCategorized: true
}

const defaultState = {
  open: false, // is open ?
  edit: false, // is edit ?
  checked: false, // checkbox checked state
  selected: false // radio checked state
}

const defaultItem = {
  id: '',
  text: 'New Category',
  path: []
}

export default {
  name: 'CategoryList',
  components: {
    CategoryItem,
    UnCategorized
  },
  props: [
    'locale',
    'edit',
    'mode',
    'option',
    'state',
    'setCheck'
  ],
  data () {
    let modes = typeof (this.mode) === 'undefined' ? defaultMode : this.mode
    let options = Object.assign({}, defaultOption, this.option)
    let states = Object.assign({}, defaultState, this.state)
    let isCheckedAll = typeof (this.option) !== 'undefined' && typeof (this.option.checkAll) !== 'undefined'
    // let setChecks = typeof (this.setCheck) === 'undefined' ? [] : this.setCheck

    return {
      depth: 0,
      modes,
      options,
      states,
      isCheckedAll,
      checkedAll: true,
      unCategorized: {
        id: 'uncategorized',
        text: 'uncategorized'
      }
    }
  },
  computed: {
    ...mapGetters({
      categoryList: 'category/list',
      categoryName: 'category/categoryName'
    }),
    setChecks: {
      get () {
        const checkedIds = typeof (this.setCheck) === 'undefined' ? [] : this.setCheck
        return checkedIds
      },
      set (ids) {
        this.$store.commit('category/updateCheckedPath', ids)
      }
    },
    listData () {
      return this.categoryList
    }
  },
  created () {
    this.init()
  },
  methods: {
    ...mapActions([
      'category/updateList'
    ]),
    init () {
      const isCheckedAll = this.isCheckedAll
      const setCheck = this.setCheck || []
      this.$store.commit('category/updateChecked', setCheck)
      this.$store.dispatch('category/setCategoryData').then((res) => {
        if (isCheckedAll) {
          this.$store.commit('category/checkedAll')
        }
      })
    },
    addList: function () {
      let addChild = Object.assign({}, defaultItem)
      addChild.id = UNIQUE.mid()
      this.listData.push(addChild)
    },
    addItem: function (item) {
      let addChild = Object.assign({}, defaultItem)
      addChild.id = UNIQUE.mid()
      if (item.children && item.children.length) {
        item.children = this._.concat(item.children, addChild)
      } else {
        this.$set(item, 'children', [addChild])
      }
    },
    removeItem: function (item, rootIndex, index) {
      if (window.confirm(this.locale.confirm_delete_category)) {
        const isChildren = typeof (index) !== 'undefined'
        isChildren
          ? this.$delete(this.listData[rootIndex].children, index)
          : this.$delete(this.listData, rootIndex)
      }
    },
    checked: function (item) {
      // console.log(item)
    },
    onCheckedAll: function (e) {
      const isChecked = e.target.checked
      this.states.checked = isChecked
      isChecked
        ? this.$store.commit('category/checkedAll')
        : this.$store.commit('category/unCheckedAll')
    },
    selected: function (item) {
      this.$emit('selected', item)
    }
  }
}
</script>
